import HomeRounded from "@mui/icons-material/HomeRounded";
import DashboardRounded from "@mui/icons-material/DashboardRounded";
import DescriptionRounded from "@mui/icons-material/DescriptionRounded";
import CloudSyncRounded from "@mui/icons-material/CloudSyncRounded";
import NotificationsRounded from "@mui/icons-material/NotificationsRounded";
import PeopleAltRounded from "@mui/icons-material/PeopleAltRounded";
import BadgeRounded from "@mui/icons-material/BadgeRounded";
import LockPersonRounded from "@mui/icons-material/LockPersonRounded";
import TuneRounded from "@mui/icons-material/TuneRounded";
import PsychologyRounded from "@mui/icons-material/PsychologyRounded";
import PersonRounded from "@mui/icons-material/PersonRounded";
import SettingsSuggestRounded from "@mui/icons-material/SettingsSuggestRounded";
import { SvgIconComponent } from "@mui/icons-material";
import type { Area } from "../context/AccessContext";

/** Os módulos do produto. Espelha `CAPACIDADES` em src/canonical/parametros.py. */
export type Modulo = "vendas" | "compras";

export interface NavItem {
  id: string;
  label: string;
  path: string;
  Icon: SvgIconComponent;
  badge?: string;
  // sem area: todo mundo ve (Home, Permissoes = o proprio acesso, Meu perfil)
  area?: Area;
}

export interface NavSection {
  id: string;
  label?: string;
  items: NavItem[];
  /**
   * Seção que só existe para quem contratou o módulo.
   *
   * O menu antes prometia o que o contrato não tinha: um cliente só de vendas
   * via "Relatórios" e "Notificações", que existem apenas para o plano de
   * compra, e abria as duas vazias. A separação por módulo não é organização
   * visual — é parar de oferecer o que não foi vendido.
   */
  modulo?: Modulo;
}

export const NAV: NavSection[] = [
  {
    id: "principal",
    items: [
      { id: "home", label: "Home", path: "/", Icon: HomeRounded },
      { id: "dashboards", label: "Dashboards", path: "/dashboards", Icon: DashboardRounded, area: "dashboards" },
    ],
  },
  {
    id: "vendas",
    label: "Vendas",
    modulo: "vendas",
    items: [
      // Não configura: informa. A tela responde "o módulo está de pé?" —
      // contratado, e se o dado da carga sustenta cada capacidade. Havia
      // TRÊS itens chamados "Configurações" no mesmo menu, nenhum deles com
      // campo editável.
      // A primeira tela do módulo que fala de VENDA, e não de configuração.
      { id: "vendedores", label: "Vendedores", path: "/vendedores", Icon: BadgeRounded, area: "vendedores" },
      {
        id: "modulo-vendas", label: "Situação do módulo", path: "/modulos/vendas",
        Icon: SettingsSuggestRounded, area: "modulos",
      },
    ],
  },
  {
    id: "compras",
    label: "Compras",
    modulo: "compras",
    items: [
      // Relatórios e Notificações sempre foram de compras na prática:
      // `mart_purchase_plan` e `purchase_suggestion_report_notifications`.
      // Estavam em "principal" por acidente de ordem, não por decisão.
      { id: "relatorios", label: "Relatórios", path: "/relatorios", Icon: DescriptionRounded, area: "relatorios" },
      { id: "notificacoes", label: "Notificações", path: "/notificacoes", Icon: NotificationsRounded, area: "notificacoes" },
      {
        id: "modulo-compras", label: "Situação do módulo", path: "/modulos/compras",
        Icon: SettingsSuggestRounded, area: "modulos",
      },
    ],
  },
  {
    id: "gestao",
    label: "Gestão",
    items: [
      { id: "integracoes", label: "Integrações", path: "/integracoes", Icon: CloudSyncRounded, area: "integracoes" },
      { id: "usuarios", label: "Usuários", path: "/usuarios", Icon: PeopleAltRounded, area: "usuarios" },
      { id: "permissoes", label: "Permissões", path: "/permissoes", Icon: LockPersonRounded },
      // "Configurações" convidava a configurar: `/config` não configura nada.
      // Mostra a base publicada, a identidade e dois blocos que nunca
      // preenchem (templates do WhatsApp e cronjobs). É um retrato, não um
      // formulário — e o nome agora diz isso.
      { id: "config", label: "Ambiente", path: "/config", Icon: TuneRounded, area: "configuracoes" },
      { id: "modelo-ia", label: "Modelo de IA", path: "/modelo-ia", Icon: PsychologyRounded, area: "configuracoes.llm" },
    ],
  },
  {
    id: "conta",
    label: "Conta",
    items: [
      { id: "perfil", label: "Meu perfil", path: "/perfil", Icon: PersonRounded },
    ],
  },
];
